import axios from 'axios';
import axiosRetry from 'axios-retry';
import { getService } from '@innovyze/stylovyze/lib/utils/getService';
import { getBearerAuth0Token } from '@innovyze/stylovyze/lib/utils/authUtils';
import { formatUrlTrailing } from '@innovyze/stylovyze/lib/utils/urlFormatting';
import config from './config.api';
export const endpoint = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://aws.com/api/v2';
const apiEnv = localStorage.getItem('apiEnv') || undefined;
export const incidentBaseUrl = formatUrlTrailing(getService('incident', config, apiEnv));
const options = {
    baseURL: incidentBaseUrl,
    timeout: 10000,
};
const service = axios.create(options);
service.interceptors.request.use(requestConfig => {
    requestConfig.headers.Authorization = getBearerAuth0Token();
    return requestConfig;
}, error => {
    Promise.reject(error);
});
axiosRetry(service, {
    retries: 3,
    retryDelay: retryCount => {
        return retryCount * 1000;
    },
});
export default service;
